import { useSession } from "next-auth/react";
import { useQuery } from "react-query";
import { format } from "date-fns";
import { ComponentHeader } from "./ComponentHeader";
import { getUpcomingTournaments } from "../api/tournaments";
import ImageWithFallback from "./ImageWithFallback";
import { sortBy } from "lodash";
const Tournaments = () => {
  const { data: session }: any = useSession();
  const accessToken = session?.accessToken;

  const { isLoading, error, data } = useQuery(
    "tournaments",
    () => getUpcomingTournaments(accessToken),
    {
      enabled: !!accessToken,
    },
  );

  if (isLoading) return <p>Loading...</p>;

  if (error) {
    return <p>An error has occurred</p>;
  }

  interface Tournament {
    id: string;
    name: string;
    date: Date;
    course: string;
    picture: string;
  }

  const tournament = (
    id: string,
    tournament_name: string,
    tournament_date: Date,
    course: string,
    picture: string,
  ) => {
    return (
      <div
        key={id}
        className="flex flex-row bg-white rounded-[8px] overflow-hidden h-[84px] mb-[8px] shadow-[2px_2px_10px_0px_#00000014]"
      >
        <ImageWithFallback
          src={
            picture ||
            "https://stgolfchampsprodeastus.blob.core.windows.net/public/Default.jpg"
          }
          fallBackSrc="https://stgolfchampsprodeastus.blob.core.windows.net/public/Default.jpg"
          width="84"
          height="84"
          // layout='fill'
          // className="object-contain"
          alt={tournament_name}
          unoptimized
        />
        <div className="flex flex-col flex-1 font-['Montserrat'] text-black p-[16px]">
          <div className="text-[14px] font-bold">{tournament_name}</div>
          <div className="text-[12px] font-normal">
            {format(new Date(tournament_date), "EEEE do LLL yyyy")}
          </div>
          <div className="text-[12px] font-normal">{course}</div>
        </div>
      </div>
    );
  };

  if (data) {
    const tournaments = sortBy(data, (i) => i.date).map((item: Tournament) =>
      tournament(item.id, item.name, item.date, item.course, item.picture),
    );
    return (
      <div className="font-['Montserrat']">
        <div className="font-bold text-[16px] py-[10px] uppercase">
          Upcoming Tournaments
        </div>
        {tournaments}
        {tournaments.length == 0 && (
          <p className="text-center font-serif text-gray-400">
            There are no upcoming tournaments
            <br />
            <span className="text-2xl">😢</span>
          </p>
        )}
      </div>
    );
  } else return <p>Loading</p>;
};

export default Tournaments;
